import React from 'react';
import PropTypes from 'prop-types';
import nds from '@nerdwallet/base-styles/classes';
import MarketplaceStarRating, {
  LAYOUTS,
} from '@nerdwallet/react-marketplace-star-rating';

const StarRating = ({ marketplaceEntity }) => (
  // 170px will keep the star rating on two lines rather than flowing over to three
  <div style={{ minWidth: '170px' }} data-integration="star-rating">
    <MarketplaceStarRating
      marketplaceEntity={marketplaceEntity}
      hideNumber
      layout={LAYOUTS.STACKED}
      className={nds('margin-vertical-2', 'text-align-center')}
    />
  </div>
);

StarRating.propTypes = {
  marketplaceEntity: PropTypes.object,
};

export default StarRating;
